import { v as bvVar } from 'bv';

const {
  hasSportsbook = true,
  hasCasino = true,
  showTopLevelNavigation = true,
  homeProduct = 'sports',
  showQuickbetDefault = true,
  showBetslipAcceptAllPriceChanges = false,
} = bvVar('siteConfigs').global || {};

export {
  hasSportsbook,
  hasCasino,
  showTopLevelNavigation,
  homeProduct,
  showQuickbetDefault,
  showBetslipAcceptAllPriceChanges,
};
